module.exports = __webpack_public_path__ + "img/strip-17.e0af3220.jpg";